export const style = {
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--header-background,#071013)',
    height: '75px',
    color: 'var(--header-text ,#F0F8FF)',
    fontFamily: 'Inter, sans-serif',
    fontWeight: '700',
    bottom: '0',
    left: '0',
    right: '0',
  },
  marginRight: {
    marginRight: '1rem'
  },
  mobileFooter: {
    flexDirection: 'column-reverse',
    transform: 'scale(.65)'
  }
};